<template>
  <div class="container-filho" style="width:100%">
    <Titulo :title="titulo" />
    <div class="div_reserva_total" style="margin-top: 0px;">
      <div style="margin:10px">
        <div class="card_projeto_vida">
          <div class="card_projeto_vida_topo">
            <dd class="dd_reserva_text" v-if="toggleMoney" style="text-align: start;">
              <span class="span_reserva_text_1">R$</span>
              <span class="span_reserva_text_2">{{ formatMoedaProjetoVida(saldo_total, false) }}</span>
            </dd>
            <dd class="dd_reserva_text" v-if="!toggleMoney" style="text-align: start;">
              <span class="span_reserva_text_1">R$</span>
              <span class="span_reserva_text_2">* * * *</span>
            </dd>
          </div>
          <div class="card_projeto_vida_topo_options">
            <div style="display: flex; justify-content: space-evenly; align-items:center; margin: 0px 15px;">
              <img v-if="toggleMoney" @click.prevent="toggleSeeMoney()" src="../../public/images/icons/eye.png" alt=""
                style="height: 20px; cursor: pointer;">
              <img v-if="!toggleMoney" @click.prevent="toggleSeeMoney()" src="../../public/images/icons/eye-off.png"
                alt="" style="height: 20px; cursor: pointer;">
                <div v-if="reservaSetting.projeto_previdenciario && !bloqueia_reserva"
                @click.prevent="acessarProjetoDeVida()">
                <ChevronRight :size=40 style="cursor: pointer; color: black;" />                
              </div>
            </div>
          </div>
        </div>
        <div style="width:100%; margin-top:-10px; margin-bottom:40px">
          <span class="span_data_base">Saldo Total - base: {{ dataBaseReserva || '' }}</span>
        </div>
      </div>
    </div>
    <GraficoProjetoVida class="canvas_grafico_line" style="margin: auto" />
    <Disclaimer :tipo="disclaimerTipo" />
    <div class="mdl-card-left">
      <dl>
        <div v-for="projecao in projetoVida.projecao" :key="projecao.nome">
          <dt class="dt_projeto_vida">{{ projecao.nome }}</dt>
          <dd class="dd_projeto_vida" :style="projecao.cor">{{ formatMoeda(projecao.valor, true) }}</dd>
        </div>
      </dl>
    </div>
    <div class="mdl-card-right" v-if="projetoVida.coberturas">
      <dl>
        <div v-for="coberturas in projetoVida.coberturas.itens" :key="coberturas.nome">
          <dt class="dt_projeto_vida">{{ coberturas.nome }}</dt>
          <dd class="dd_projeto_vida" :style="coberturas.cor">{{ formatMoeda(coberturas.valor, true) }}</dd>
        </div>
      </dl>
    </div>
    <!--mini card ação-->
    <MiniCardAcao v-if="statusParticipacao !== 'Novo'" :texto="textoMiniCard" :router="'/renda'" />
  </div>
</template>

<script>
import { mapGetters, mapActions} from "vuex";
import Titulo from './Titulo.vue'
import Disclaimer from './Disclaimer.vue'
import GraficoProjetoVida from './GraficoProjetoVida.vue'
import MiniCardAcao from './MiniCardAcao.vue'
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

const financeiro = require("../../functions/geral/Financeiro")

export default {
  components: {
    Titulo,
    Disclaimer,
    GraficoProjetoVida,
    MiniCardAcao,
    ChevronRight
  },
  props: {
    titulo: "",
    contratacao_contrib: false,
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      plano: "plano",
      dataBaseReserva: "dataBaseReserva",
      statusParticipacao: "statusParticipacao",
    }),
  },
  data() {
    return {
      valores: null,
      rdi:{},
      toggle: false,
      toggleMoney: false,
      disclaimerTipo: 'RENDA',
      contratacaoContrib: true,
      segmento: null,
      meses: [{ indice: 0, nome: 'Jan' },
      { indice: 1, nome: 'Fev' },
      { indice: 2, nome: 'Mar' },
      { indice: 3, nome: 'Abr' },
      { indice: 4, nome: 'Mai' },
      { indice: 5, nome: 'Jun' },
      { indice: 6, nome: 'Jul' },
      { indice: 7, nome: 'Ago' },
      { indice: 8, nome: 'Set' },
      { indice: 9, nome: 'Out' },
      { indice: 10, nome: 'Nov' },
      { indice: 11, nome: 'Dez' }
      ],
      textoMiniCard: '',
      acessoProjetoDeVida: true,
      reservaSetting: {
        extrato_investimento: true,
        extrato_ir: true,
        projeto_previdenciario: true,
        rendimento_acumulado: true,
        saldo_resgatavel: true,
        saldo_total: true
      },
      projetoVida: {
        grafico: {}
      },
      saldo_total: 0,
      bloqueia_reserva: false,
    }
  },
  created() {    
    this.rdi = this.participante.rdi
    if ((this.participante.projetoVida|| {} ).setting) {
      this.reservaSetting = this.participante.projetoVida.setting
    }
    if (this.participante.projetoVida) {
      this.projetoVida = this.participante.projetoVida
    }
    if (this.statusParticipacao === 'Novo') {
      this.bloqueia_reserva = true;
      var data2 = new Date();
      var mes2 = "0" + (data2.getMonth() + 1);
      this.atualizarEstadoDataBaseReserva(`${mes2.substring(mes2.length - 2)}/${data2.getFullYear()}`)
    } else if (((this.rdi || {}).historicoReserva || {}).posicao) {
      var data = new Date(this.rdi.historicoReserva.posicao);
      var mes = this.meses.find((mes) => mes.indice === data.getMonth());
      this.atualizarEstadoDataBaseReserva(`${mes.nome}/${data.getFullYear()}`)
      this.saldo_total = (((this.rdi.historicoReserva || {}).saldo || {}).total || {}).valor || 0;
    }
    if (this.saldo_total === 0 && (this.participante.data.valores.contribParticipante || 0) > 0) {
      this.saldo_total = this.participante.data.valores.contribParticipante
    }
    //se depois de tudo o saldo ainda for zero... bloqueia
    if (this.saldo_total === 0) {
      this.bloqueia_reserva = true
    }    
    this.contratacaoContrib = this.contratacao_contrib
    if (this.contratacaoContrib) {
      this.textoMiniCard = 'Seu novo Projeto de Vida estará vigente para a próxima competência disponível, veja aqui'
    } else {
      this.textoMiniCard = (this.projetoVida || {}).acao || 'Seu novo Projeto de Vida estará vigente para a próxima competência disponível, veja aqui'
    }
    this.segmento = this.participante.segmento
    this.preencherSegmento()
    //this.verificarAcessoProjetoDeVida()
  },
  methods: {
    ...mapActions(["atualizarEstadoDataBaseReserva"]),
    // verificarAcessoProjetoDeVida() {
    //   this.acessoProjetoDeVida = true
    // },
    preencherSegmento() {
      if (this.projetoVida && this.projetoVida.projecao && this.projetoVida.coberturas) {
        for (var i = 0; i < this.projetoVida.projecao.length; i++) {
          this.projetoVida.projecao[i].cor = this.segmento.seg_projeto_vida.itens.projecao[i].cor
        }
        for (var i = 0; i < this.projetoVida.coberturas.itens.length; i++) {
          this.projetoVida.coberturas.itens[i].cor = this.segmento.seg_projeto_vida.itens.coberturas[i].cor
        }
      }
    },
    toggleCategory() {
      this.toggle = !this.toggle;
    },
    toggleSeeMoney() {
      this.toggleMoney = !this.toggleMoney
    },
    formatMoeda(value, incluiCifrao) {
      if (value === 0) {
        return "(não contratado)"
      } else if (value && value !== 0) {
        let val = financeiro.valor_to_string_formatado(value, 2, incluiCifrao, true)
        return val
      }
    },
    formatMoedaProjetoVida(value, incluiCifrao) {
      let val = financeiro.valor_to_string_formatado(value, 2, incluiCifrao, true)
      return val
    },
    acessarProjetoDeVida() {
      this.$root.$router.push({
        path: '/meuextrato',
        query: { reservaSetting: this.reservaSetting }
      })
    }
  }
}
</script>

<style scoped>
.card_projeto_vida {
  margin: 40px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card_projeto_vida_topo {
  padding-left: 10px;
  width: 80%;
  display: block;
  justify-content: left;
}

.card_projeto_vida_topo_options {
  width: 20%;
  display: block;
  justify-content: right;
}

.mdl-card-right {
  float: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 49%;
}


.span_data_base {
  font-weight: bold;
  font-size: 13px;
  font-family: 'MaisFuturo-Thin';
  padding-left: 20px;
}
</style>
